import { defineStore } from 'pinia'

/**
 * 金库认证
 */
export const useTreasuryAuthStore = defineStore({
  id: 'treasuryAuthStore',
  state: () => ({
    jkConfigName: '',
    jkAuthDialogVisible: false
  }),
  actions: {
    changeJKConfigName(name: string) {
      this.jkConfigName = name
    },
    changeJKAuthDialogVisible(visible: boolean) {
      this.jkAuthDialogVisible = visible
    }
  }
})
